import React from "react";
import {
  Header,
  Abstract,
  AboutUs,
  Author,
  Footer,
  Manuscript,
  Acknowledgements,
} from "../../container";

import "./MainPage.css";

const MainPage = () => (
  <div>
    <Header />
    <Abstract />
    <AboutUs />
    <Manuscript />
    <Author />
    <Acknowledgements />
    <Footer />
  </div>
);

export default MainPage;
